import $ from 'jquery';

export default () => {
  $('.nav-drop .back-btn').click(function backNav() {
    $(this).parent().removeClass('active');
  });
};
